import { z } from 'zod';

import { defineQuery } from '@nesso/common-contracts/define';
import { metadata } from '@nesso/common-contracts/schema-metadata';

import { practiceMemberIdSchema } from './ids';
import {
    NOTES_SETTINGS_TYPE,
    notesSettingsValueSchema,
    PRACTICE_MEMBER_SETTINGS_TYPES,
    TELEHEALTH_SETTINGS_TYPE,
    telehealthSettingsValueSchema,
} from './practice-member-settings.models';

export const GET_PRACTICE_MEMBER_SETTINGS_BY_TYPE_TYPE = 'practice-member-settings/get-by-type';

export const practiceMemberSettingsSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal(NOTES_SETTINGS_TYPE), value: notesSettingsValueSchema }),
    z.object({ type: z.literal(TELEHEALTH_SETTINGS_TYPE), value: telehealthSettingsValueSchema }),
]);

export type PracticeMemberSettingsValue = z.infer<typeof practiceMemberSettingsSchema>;

export const getPracticeMemberSettingsByType = defineQuery(
    GET_PRACTICE_MEMBER_SETTINGS_BY_TYPE_TYPE,
    z.object({
        practiceMemberId: practiceMemberIdSchema.meta(metadata.recordId),
        type: z.enum(PRACTICE_MEMBER_SETTINGS_TYPES),
    }),
    practiceMemberSettingsSchema,
);
